import React from 'react'
import AboutMain from '../components/about-us/AboutMain'
import TopHeader from '../layout/TopHeader'
import MainHeader from '../layout/MainHeader'
import AboutUs from '../components/about-us/AboutUs'
import AboutOurMission from '../components/about-us/AboutOurMission'
import AboutCoreValues from '../components/about-us/AboutCoreValues'
import AboutTeamSpirit from '../components/about-us/AboutTeamSpirit'
import AboutProfessionalLabTesting from '../components/about-us/AboutProfessionalLabTesting'
import AboutContactUs from '../components/about-us/AboutContactUs'
import Footer from '../layout/Footer'
import CopyRight from '../layout/CopyRight'
import MainResHeader from '../layout/MainResHeader'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { useEffect } from 'react'

const AboutPage = () => {
  useEffect(()=>{
    window.scrollTo(0,0)
  },[])
  return (
    <div style={{ overflow: 'hidden' }}>

      <HelmetProvider>
        <Helmet prioritizeSeoTags>
          <title>About | United Lab Care</title>
          <link rel="canonical" href="https://unitedlabcare.com/about/" />
          <meta property="og:locale" content="en_US" />
          <meta property="og:type" content="article" />
          <meta property="og:title" content="About | United Lab Care" />
          <meta property="og:description" content="Best laboratory testing center in Chicagoland Area Best laboratory testing center in Chicagoland area About Us Lab Testing Services in Chicago Because of our consistent dedication to regulatory compliance, scientific standards, integrity, and impartiality, both established and growing companies rely on us. We have a strong and highly qualified team who can manage your testing &hellip; About Read More &raquo;" />
          <meta property="og:url" content="https://unitedlabcare.com/about/" />
          <meta property="og:site_name" content="United Lab Care" />
          <meta property="article:modified_time" content="2023-03-29T12:34:39+00:00" />
          <meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2022/12/About-Us-img1-v1.webp" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:label1" content="Est. reading time" />
          <meta name="twitter:data1" content="3 minutes" />
        </Helmet>
      </HelmetProvider>
      <TopHeader />
      {/* <MainHeader/> */}
      <MainResHeader />

      <AboutMain />
      <AboutUs />
      <AboutOurMission />
      <AboutCoreValues />
      <AboutTeamSpirit />
      <AboutProfessionalLabTesting />
      <AboutContactUs />

      <Footer />
      <CopyRight />

    </div>
  )
}

export default AboutPage